<template>
  <div>
    <patrol-search :default-user-robot="1" title="AI电话（匹配）" />
  </div>
</template>

<script>
import PatrolSearch from '@/views/actor/PatrolSearch'

export default {
  name: 'VideoAiMatch',
  components: {
    PatrolSearch
  }
}
</script>
